import React, { useState } from 'react'
import MUIDataTable from 'mui-datatables'
import PropTypes from 'prop-types'
import { parse, format } from 'date-fns'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Form from '../common/Forms/Form'
import { Select } from '../common/Forms/Select'
import classes from './SchoolNoteSchoolForm.module.sass'
import { Input } from '../common/Forms/Input'
import { DatePicker } from '../common/Forms/DatePicker'
import axios from 'axios'
import { Note } from '../../models/_models'

export default function NotesTable({ school, notes, addNote }) {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))
  const [isNewNote, setIsNewNote] = useState(false)

  const [currentNote, setCurrentNote] = useState()
  const [open, setOpen] = useState(false)

  const handleSubmit = (newValues) => {
    if (!currentNote) return

    currentNote.attributes = { ...currentNote.attributes, ...newValues }

    currentNote
      .save()
      .then(() => {
        if (isNewNote) {
          addNote(currentNote)
          setIsNewNote(false)
        }
        toast('Save successful')
        closeModal()
      })
      .catch(() => {
        toast.error('Error saving')
        setIsNewNote(false)
      })
  }

  const openModal = (note) => {
    setCurrentNote(note)
    setOpen(true)
    setIsNewNote(true)
  }

  const closeModal = () => setOpen(false)

  const columns = ['ID', 'Note', 'Visit Date', 'Follow Up Date', 'Edit']

  const data = notes.map((note) => ([
    note.id,
    note.note,
    note.visitDate ? format(parse(note.visitDate, 'y-L-d', new Date()), 'M/d/y') : '',
    note.followUpDate ? (format(parse(note.followUpDate, 'y-L-d', new Date()), 'M/d/y')) : '',
    <Button variant="outlined" color="primary" onClick={() => openModal(note)}>Edit</Button>,
  ]))

  const addNewNote = () => {
    const newNote = new Note({ schoolId: school.id, priority: 1 })
    openModal(newNote)
  }

  if (currentNote) console.log(currentNote.followUpDate)

  return (
    <>
      <ToastContainer
        position="bottom-left"
      />
      <Dialog
        classes={{ paper: classes.modal }}
        fullScreen={fullScreen}
        fullWidth
        maxWidth="md"
        open={open}
      >
        <DialogTitle>Edit Note</DialogTitle>
        <DialogContent>
          {currentNote && (
            <>
              <Form
                defaultValues={{
                  visitDate: currentNote.visitDate || null,
                  followUpDate: currentNote.followUpDate || null,
                }}
                onSubmit={handleSubmit}
              >
                <Input
                  rows={3}
                  multiline
                  animated={false}
                  defaultValue={currentNote.note}
                  fullWidth
                  label="Content"
                  name="note"
                />
                <DatePicker
                  containerClass={`${classes.datePicker} ${classes.pr}`}
                  label="Visit Date"
                  name="visitDate"
                />
                <DatePicker
                  containerClass={classes.datePicker}
                  label="Follow Up Date"
                  name="followUpDate"
                />
                <Select
                  label="Priority"
                  defaultValue={{ label: currentNote.priority, value: currentNote.priority }}
                  name="priority"
                  isSearchable={false}
                  options={[
                    { value: 1, label: '1' },
                    { value: 2, label: '2' },
                    { value: 3, label: '3' },
                    { value: 4, label: '4' },
                    { value: 5, label: '5' },
                    { value: 6, label: '6' },
                    { value: 7, label: '7' },
                    { value: 8, label: '8' },
                    { value: 9, label: '9' },
                    { value: 10, label: '10' },
                  ]}
                />
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <Button
                      fullWidth={fullScreen}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={closeModal}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Box pt={1} pb={1}>
        <Grid container justifyContent="flex-end">
          <Grid item xs="auto">
            <Button variant="outlined" color="primary" onClick={addNewNote}>Add New Note</Button>
          </Grid>
        </Grid>
      </Box>
      <MUIDataTable
        columns={columns}
        data={data}
        options={{
          response: 'vertical',
          onRowsDelete: async (rowsDeleted) => {
            const rowsToDelete = rowsDeleted.data.map((d) => data[d.dataIndex][0])

            const res = await axios
              .delete('/notes/mass_delete', {
                data: {
                  ids: rowsToDelete,
                },
              })

            if (res.status === 200) toast('Successfully deleted', { position: "bottom-left" })
            else toast.error('Error processing', { position: "bottom-left" })
          },
        }}
        title="Notes"
      />
    </>

  )
}

NotesTable.propTypes = {
  notes: PropTypes.array.isRequired,
}
